function getCheckedCodeMap(checkedCodes = []) {
  return checkedCodes.reduce((map, code) => {
    if (code) {
      map[code] = true
    }
    return map
  }, {})
}

function updateCheckedCodes(checkedCodes = [], rows = [], codeField, checked) {
  const checkedCodeMap = getCheckedCodeMap(checkedCodes)

  rows.forEach((row) => {
    const code = row && row[codeField]
    if (!code) return

    if (checked) {
      checkedCodeMap[code] = true
      return
    }

    delete checkedCodeMap[code]
  })

  return Object.keys(checkedCodeMap)
}

function getCheckedRows(rows = [], codeField, checkedCodes = []) {
  const checkedCodeMap = getCheckedCodeMap(checkedCodes)

  return rows.filter((row) => row && checkedCodeMap[row[codeField]])
}

function isGroupChecked(row = {}, codeField, checkedCodeMap = {}) {
  const children = row.children || []

  return (
    children.length > 0 &&
    children.every((child) => child && checkedCodeMap[child[codeField]])
  )
}

export {
  getCheckedCodeMap,
  updateCheckedCodes,
  getCheckedRows,
  isGroupChecked,
}
